export const isXmlInvoice = state => state.invoiceBase64File && state.invoiceBase64File.length > 10 && state.invoiceBase64File.indexOf('application/pdf') === -1;
export const isPdfInvoice = state => state.invoiceBase64File && state.invoiceBase64File.length > 10 && state.invoiceBase64File.indexOf('application/pdf') > -1;
export const isEmptyInvoiceFile = state => !state.invoiceBase64File;

export const getInvoiceById = state => id => state.invoiceList.find(item => item.id === id);

export default {
  isXmlInvoice,
  isEmptyInvoiceFile,
  isPdfInvoice,
  getInvoiceById,
};




// WEBPACK FOOTER //
// ./src/store/getters.js